import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";

type Tag = {
  name: string;
  background_color: string;
  color: string;
  long_name: string;
  slug: string;
};

const energyDataAcquisitionTagsQuery = queryOptions({
  queryKey: ["eda-tags"],
  queryFn: async () =>
    (
      await apiWithoutCamelization.get<Tag[]>(
        urls.api.energyDataAcquisitionTags()
      )
    ).data,
  staleTime: Infinity
});
function useEnergyDataAcquisitionTags() {
  return useQuery(energyDataAcquisitionTagsQuery);
}

export { useEnergyDataAcquisitionTags };
